import { Component } from 'react'
import { Link } from 'react-router-dom';
import React from 'react';
import { Card, Badge } from './ui';
import { normalizeImageUrl } from '../utils/imageUtils';
import { formatHandle } from '../utils/usernameUtils';
import api from '../api/http';

export default class StoreItems extends Component{

    state = {
        items:[],
        favourites:[],
        updatedItems:[]

    }


    constructor(props){
        super(props);
        const dataSafe = Array.isArray(props.data) ? props.data : [];
        this.state = {
            items: dataSafe,
            favourites: Array.isArray(props.favourites) ? props.favourites : [],
            updatedItems: []
        };
    }
    componentDidMount(){
        const dataSafe = Array.isArray(this.props.data) ? this.props.data : [];
        if(this.state.items !== dataSafe){
            this.setState({items: dataSafe});
        }
        if(Array.isArray(this.props.favourites)){
            this.setState({favourites: this.props.favourites});
        }
    }
    componentDidUpdate(prevProps){
        if(prevProps.data !== this.props.data){
            const dataSafe = Array.isArray(this.props.data) ? this.props.data : [];
            this.setState({items: dataSafe});
        }
        if(prevProps.favourites !== this.props.favourites && Array.isArray(this.props.favourites)){
            this.setState({favourites: this.props.favourites});
        }
    }
    
    
    render(){
        

        const favourite = (id) =>{
            const favouritesSafe = Array.isArray(this.state.favourites) ? this.state.favourites : [];
            if(id && favouritesSafe.includes(id)){
                return require('../assets/favourite_red.png')
            }
            return require('../assets/favourite.png')
        }

        const update = async (id) => {
            if (!id) return;
            
            const favouritesSafe = Array.isArray(this.state.favourites) ? this.state.favourites : [];
            const user = this.props.user;
            
            // Check if user is authenticated - show non-blocking message, do not open modal
            if (!user) {
                if (this.props.onLoginPrompt) {
                    this.props.onLoginPrompt();
                }
                return;
            }
            
            // Optimistically update UI
            const isCurrentlyFavourite = favouritesSafe.includes(id);
            if(isCurrentlyFavourite){
                const updated = favouritesSafe.filter((item) => item !== id);
                this.setState({favourites: updated});
            } else {
                this.setState({favourites: [...favouritesSafe, id]});
            }
            
            // Call API
            try {
                await api.post('/api/profile/favourites/update', {
                    itemID: id, 
                    username: user
                });
                
                // Refresh favourites from parent if refresh callback is provided
                if(this.props.refresh){
                    this.props.refresh();
                }
            } catch (error) {
                console.error('Error updating favourites:', error);
                // Revert optimistic update on error
                this.setState({favourites: favouritesSafe});
            }
        }

        

        

        const itemsSafe = Array.isArray(this.state.items) ? this.state.items : [];
        const favouritesSafe = Array.isArray(this.state.favourites) ? this.state.favourites : [];

        if(itemsSafe.length === 0){
            // Check if this is being used for similar items (has showEmptyState prop)
            const isSimilarItems = this.props.showEmptyState;
            
            // Choose icon path based on context
            const iconPath = isSimilarItems 
                ? "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"  // Shopping bag
                : "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4";  // Box
            
            return (
                <div className="flex flex-col items-center justify-center py-16 px-4">
                    <svg 
                        className="w-24 h-24 text-[var(--color-muted)] mb-4" 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={iconPath} />
                    </svg>
                    <h3 className="text-xl font-semibold text-[var(--color-text)] mb-2">
                        {isSimilarItems ? 'No similar items yet' : 'No items found'}
                    </h3>
                    <p className="text-base text-[var(--color-muted)] text-center max-w-md">
                        {isSimilarItems 
                            ? 'Check back later or browse the store to discover more items.' 
                            : 'Try adjusting your search or filters to find what you are looking for.'}
                    </p>
                </div>
            );
        }

        return(
            <div data-testid="storeitems" className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4'>
                {
                    itemsSafe.map(item => {
                        if(!item || !item._id) return null;
                        
                        const isFavourite = favouritesSafe.includes(item._id);
                        
                        return(
                            <Card 
                                data-testid="itemid" 
                                key={item._id}
                                className="group hover:shadow-md transition-shadow duration-200 overflow-hidden"
                                padding="none"
                            >
                                <Link to={`/store/item/${item._id}`} className="block">
                                    <div className="relative aspect-square overflow-hidden bg-[var(--color-surface-2)]">
                                        <img 
                                            src={item.image ? normalizeImageUrl(item.image) : require('../assets/placeholder_item.png')} 
                                            alt={item.name || 'Item'}
                                            className='w-full h-full object-cover group-hover:scale-105 transition-transform duration-200'
                                            onError={(e) => {
                                                e.target.src = require('../assets/placeholder_item.png');
                                            }}
                                        />
                                    </div>
                                </Link>
                                <div className='p-4 space-y-3'>
                                    <div className="flex items-start justify-between gap-2">
                                        <h3 className="font-semibold text-[var(--color-text)] flex-1">
                                            {item.name || 'Untitled'}
                                        </h3>
                                        <button
                                            onClick={(e) => {
                                                e.preventDefault();
                                                update(item._id);
                                            }}
                                            className="p-2.5 rounded-full hover:bg-[var(--color-surface-2)] transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-primary)] min-w-[44px] min-h-[44px] flex items-center justify-center flex-shrink-0 -m-1"
                                            aria-label={isFavourite ? 'Remove from favourites' : 'Add to favourites'}
                                        >
                                            <img 
                                                src={favourite(item._id)}  
                                                className='w-5 h-5'
                                                alt={isFavourite ? 'Favourite' : 'Not favourite'}
                                            />
                                        </button>
                                    </div>
                                    <p className="text-xl font-bold text-[var(--color-primary)]">
                                        ${item.price ? parseFloat(item.price).toFixed(2) : '0.00'}
                                    </p>
                                    <div className="flex items-center justify-between gap-2">
                                        {item.category && (
                                            <span className="text-xs text-[var(--color-muted)] truncate">
                                                {item.category}
                                            </span>
                                        )}
                                        {item.owner && (
                                            <Link 
                                                to={`/user/${item.owner}`} 
                                                className='text-sm text-[var(--color-muted)] hover:text-[var(--color-primary)] hover:underline truncate'
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                {formatHandle(item.owner)}
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </Card>
                        )
                    })
                }
            </div>
        )
    }
}